// extracted by mini-css-extract-plugin
export default {"root":"ApplicationFooter_root__5Di60","action":"ApplicationFooter_action__NSGni","button":"ApplicationFooter_button__SBvxE"};